import { render, staticRenderFns } from "./CouponTable.vue?vue&type=template&id=796a35e4&scoped=true"
import script from "./CouponTable.vue?vue&type=script&lang=js"
export * from "./CouponTable.vue?vue&type=script&lang=js"
import style0 from "./CouponTable.vue?vue&type=style&index=0&id=796a35e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a35e4",
  null
  
)

export default component.exports